import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactivePortfolioItems,
  createPortfolioItems,
  deletePortfolioItems,
  getAllActivePortfolioItems,
  getAllPortfolioItems,
  getPortfolioItemsByID,
  PortfolioItemsDetailsImageUpload,
  updatePortfolioItems,
} from "./services/portfolioItem.services";
import { IPortfolioItem, IPortfolioItems } from "./portfoliioItemModal";

const initialState: IPortfolioItems = {
  loading: false,
  formLoading: false,
  error: "",
  PortfolioItemID: null,
  PortfolioItemList: [],
  PortfolioItemDetail: {
    ID: null,
    ServiceID: null,
    ServiceTitle: "",
    Title: "",
    Description: "",
    PageContent: "",
    URL: "",
    IsActive: 1,
  },
};

const portfolioitemSlice = createSlice({
  name: "portfolioitems",
  initialState,
  reducers: {
    clearPortfolioItemDetails: (state) => {
      state.PortfolioItemDetail = initialState.PortfolioItemDetail;
    },
    setPortfolioItemID: (state, action) => {
      state.PortfolioItemID = action.payload;
    },
    clearPortfolioItemID: (state) => {
      state.PortfolioItemID = initialState.PortfolioItemID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPortfolioItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPortfolioItems.fulfilled,
      (state, action: PayloadAction<IPortfolioItem[]>) => {
        state.loading = false;
        state.PortfolioItemList = action.payload || [];
      }
    );
    builder.addCase(getAllPortfolioItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PortfolioItemList = [];
    });
    builder.addCase(createPortfolioItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createPortfolioItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createPortfolioItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updatePortfolioItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updatePortfolioItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updatePortfolioItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deletePortfolioItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePortfolioItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePortfolioItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getPortfolioItemsByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getPortfolioItemsByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.PortfolioItemDetail = action.payload;
    });
    builder.addCase(getPortfolioItemsByID.rejected, (state, action) => {
      state.loading = false;
      state.PortfolioItemDetail = initialState.PortfolioItemDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActivePortfolioItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePortfolioItems.fulfilled,
      (state, action: PayloadAction<IPortfolioItem[]>) => {
        state.loading = false;
        state.PortfolioItemList = action.payload || [];
      }
    );
    builder.addCase(getAllActivePortfolioItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PortfolioItemList = [];
    });
    builder.addCase(ActiveInactivePortfolioItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactivePortfolioItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactivePortfolioItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(PortfolioItemsDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(PortfolioItemsDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      PortfolioItemsDetailsImageUpload.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );
  },
});

export const {
  clearPortfolioItemDetails,
  clearPortfolioItemID,
  setPortfolioItemID,
} = portfolioitemSlice.actions;
export default portfolioitemSlice.reducer;
